import { formatCpf, isCpfValid } from '@/utils/formatCpfCnpj.utils.js'
import {
  isDisputeStatusWaitingForEvidences,
  isFinalizedStatus
} from '@/enums/chargeback.enum'
import DateManager from '@utils/date-manager.utils'

const CHARGEBACK_EXPIRED_DAYS = 10

class ChargebackDetailsManager {
  data

  constructor (data) {
    this.data = data
  }

  get shouldDisplayAlert () {
    const { status } = this.detailsAdapter

    return isDisputeStatusWaitingForEvidences(status)
  }

  static remainingDays (createdAt) {
    const actualDate = new Date()
    const chargebackDate =
      DateManager.parseBrazilianLocaleDateStringToDate(createdAt)

    const diffInDays = DateManager.diffInDate(chargebackDate, actualDate)
    return CHARGEBACK_EXPIRED_DAYS - diffInDays > 0
      ? CHARGEBACK_EXPIRED_DAYS - diffInDays
      : 0
  }

  get shouldDisplayDisputeButton () {
    const { status } = this.detailsAdapter

    return isDisputeStatusWaitingForEvidences(status)
  }

  static getTimeline (createdAt, code) {
    const FIXED_STATUS = {
      label: 'status.notification',
      description: DateManager.formatShortDateToLong(
        createdAt,
        navigator.language
      ),
      status: 'completed',
      code: []
    }

    if (isDisputeStatusWaitingForEvidences(code)) {
      return [
        FIXED_STATUS,
        { label: 'status.waiting-evidences', status: 'current', code: [10] }
      ]
    }

    const timelineInitialData = [
      FIXED_STATUS,
      {
        label: 'status.waiting-evidences',
        status: '',
        code: [10]
      },
      {
        label: 'status.in-review',
        status: '',
        code: [20]
      },
      {
        label: 'status.in-progress',
        status: '',
        code: [30]
      },
      {
        label: 'status.finalized',
        status: '',
        code: [40, 90, 91, 92, 93]
      }
    ]

    if (isFinalizedStatus(code)) {
      return timelineInitialData.map(element => ({
        ...element,
        status: 'completed'
      }))
    }

    const currentStatusIndex = timelineInitialData
      .map(e => e.code)
      .findIndex(codes => codes.includes(code))

    const NOTIFICATION_STATUS_INDEX = 0
    const isUnknownStatusCode = currentStatusIndex === -1

    const resolvedStatusIndex = isUnknownStatusCode
      ? NOTIFICATION_STATUS_INDEX
      : currentStatusIndex

    const timeline = timelineInitialData.map((element, index) => {
      if (index < resolvedStatusIndex) {
        return {
          ...element,
          status: 'completed'
        }
      }

      if (index === resolvedStatusIndex) {
        return {
          ...element,
          status: 'current'
        }
      }

      return {
        ...element,
        status: 'next'
      }
    })

    return timeline
  }

  get detailsAdapter () {
    const { transactionId, createdAt, status, transactionalData, chargeback } =
      this.data

    const customerDocument = isCpfValid(transactionalData.customerDocument)
      ? formatCpf(transactionalData.customerDocument)
      : '-'

    return {
      transactionId,
      createdAt,
      status: status.code,
      amount: transactionalData.amount,
      customerDocument,
      cardHolderName: transactionalData.cardHolderName,
      cardNumber:
        transactionalData.cardFirstDigits +
        '** **' +
        transactionalData.cardLastDigits,
      cardBrand: transactionalData.cardBrand?.toUpperCase(),
      reasonDescription: chargeback.reasonDescription,
      transactionDate: transactionalData.transactionDate,
      email: transactionalData.email
    }
  }
}

export default ChargebackDetailsManager
